import "../styles/job.css";

import FeaturesSection from "../pages/FeaturesSection";
import ScrollingFeedback from "../pages/ScrollingFeedback";
import CloudJobRoles from "./CloudJobRoles";
import CloudDemand from "../pages/CloudDemand";
import CloudHero from "./CloudHero";
export default function CloudOverview() {
  return (
    <>
      {/* HERO PAGE */}
      <CloudHero />

      {/* MAIN CONTENT */}
      <section className="genai-page">

        {/* HERO TEXT */}
        <header className="genai-hero">
          <h1>Cloud Computing Starter Program (AWS)</h1>
         
        </header>

        {/* PROGRAM OVERVIEW */}
        <section className="genai-section">
          <h2>Program Overview</h2>

          <p>
            The Cloud Computing Starter Program (AWS) is designed to provide
            learners with a strong foundation in cloud computing concepts and
            hands-on experience using Amazon Web Services (AWS).
          </p>

          <p>
            This program introduces core cloud principles, AWS global
            infrastructure, compute, storage, networking, databases, security,
            serverless computing, and cost management.
          </p>

          <p>
            Participants will gain practical exposure to deploying applications
            on the cloud, managing cloud resources securely, and building
            scalable solutions using AWS Free Tier services. By the end of the
            program, learners will be able to design, deploy, monitor, and
            manage beginner-level cloud applications confidently.
          </p>
        </section>

        {/* JOB ROLES */}
        <CloudJobRoles />

        {/* CLOUD DEMAND */}
        <CloudDemand />

        {/* KEY LEARNING OUTCOMES */}
        <section className="genai-section">
          <h2>Key Learning Outcomes</h2>
          <ul className="outcome-list">
            <li>Understand cloud computing concepts and service models (IaaS, PaaS, SaaS)</li>
            <li>Navigate and use the AWS Management Console effectively</li>
            <li>Launch and manage EC2 virtual servers</li>
            <li>Store and host content using Amazon S3</li>
            <li>Configure basic networking using Amazon VPC</li>
            <li>Work with managed databases using Amazon RDS</li>
            <li>Build serverless functions using AWS Lambda</li>
            <li>Monitor cloud resources and control costs</li>
            <li>Follow AWS security best practices and Free Tier usage rules</li>
          </ul>
        </section>

        {/* WHO SHOULD ATTEND */}
        <section className="genai-section">
          <h2>Who Should Attend</h2>
          <ul className="outcome-list">
            <li>Students and fresh graduates</li>
            <li>Beginners starting a career in Cloud Computing</li>
            <li>IT professionals transitioning to cloud roles</li>
            <li>Faculty members and trainers</li>
            <li>Anyone with basic computer or programming knowledge</li>
          </ul>
        </section>

        {/* CAREER PATHWAYS */}
        <section className="genai-section">
          <h2>Career Pathways, Job Roles & Salary Range (India)</h2>

          <div className="salary-table-wrapper">
            <table className="salary-table">
              <thead>
                <tr>
                  <th>Job Role</th>
                  <th>*Entry Level Salary</th>
                  <th>*Mid-Level Salary</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Cloud Engineer</td><td>₹4 – 7 LPA</td><td>₹8 – 18 LPA</td></tr>
                <tr><td>AWS Cloud Administrator</td><td>₹3.5 – 6 LPA</td><td>₹7 – 15 LPA</td></tr>
                <tr><td>DevOps / Cloud Support Engineer</td><td>₹4 – 8 LPA</td><td>₹10 – 20 LPA</td></tr>
                <tr><td>Cloud Solutions Associate</td><td>₹4 – 7 LPA</td><td>₹9 – 18 LPA</td></tr>
                <tr><td>Junior Cloud Architect</td><td>₹6 – 10 LPA</td><td>₹15 – 30 LPA</td></tr>
                <tr><td>AWS Security Engineer</td><td>₹6 – 12 LPA</td><td>₹12 – 22 LPA</td></tr>
              </tbody>
            </table>

            <p className="salary-note">
              *Salary depends on skills, projects, and organization.
            </p>
          </div>
        </section>

        {/* PROJECT HIGHLIGHT */}
        <section className="genai-section highlight">
          <h2>Project Highlight</h2>
          <p>
            <strong>Cloud-Hosted Web Application:</strong> A real-world cloud
            solution that deploys, secures, and manages a scalable web
            application on AWS using compute, storage, networking, database,
            and monitoring services within Free Tier limits.
          </p>
        </section>

        {/* FEATURES */}
        <FeaturesSection />

        {/* SCROLLING FEEDBACK */}
        <ScrollingFeedback />

      </section>
    </>
  );
}
